import { BillingMode, InvoiceStatus, InvoiceType } from '../../../../../../services/exports/Constants';

export default {
  title: 'Fakturaer',
  form: {
    title: 'Anmod om ny betaling',
    company: {
      label: 'Restaurant',
    },
    billing_mode: {
      label: 'Faktureringskilde',
    },
    billing_anchor: {
      label: 'Start fakturering fra',
    },
    items: {
      label: 'Poster',
    },
    name: {
      label: 'Navn',
      placeholder: '1000x flyers',
    },
    net_amount: {
      label: 'Beløb (netto)',
      tax_breakdown: '+{{tax}} moms = {{total}}',
    },
  },
  fields: {
    id: 'ID',
    company: 'Restaurant',
    name: 'Navn/nummer',
    billing_mode: 'Faktureringskilde',
    type: 'Type',
    status: 'Status',
    amount: 'Beløb (brutto)',
    created_at: 'Oprettet',
    billing_anchor: 'Fakturering fra',
    invoice: 'Faktura',
  },
  billing_modes: {
    [BillingMode.Stripe]: 'Betalingsmetode',
    [BillingMode.InternalInvoicing]: 'Salg',
  },
  types: {
    [InvoiceType.Manual]: 'Manuel',
    [InvoiceType.SetupFee]: 'Oprettelsesgebyr',
    [InvoiceType.Subscription]: 'Abonnement',
  },
  statuses: {
    [InvoiceStatus.Pending]: 'Afventer',
    [InvoiceStatus.Processing]: 'Behandler',
    [InvoiceStatus.Paid]: 'Betalt',
    [InvoiceStatus.PartiallyRefunded]: 'Delvist refunderet',
    [InvoiceStatus.Refunded]: 'Refunderet',
    [InvoiceStatus.Failed]: 'Mislykkedes',
  },
  modals: {
    invoice_creation_confirmation: {
      title: 'Er du sikker på, at du vil oprette en faktura på {{amount}} netto til {{company}} fra {{billingMode}}?',
    },
    invoice_recharge_confirmation: {
      title: 'Er du sikker?',
      description:
        '<strong>{{company}}</strong> vil blive trukket igen for <strong>{{amount}} brutto + eventuelt gebyr for mislykket betaling</strong> fra den primære betalingsmetode for fakturaen {{details}}',
      recharge_failed: {
        title: 'Stripe afviste betalingen',
        convert_hint:
          'Du kan i stedet opkræve denne faktura fra restaurantens salg. Stripe-fakturaen annulleres, og det udestående beløb fratrækkes kommende udbetalinger.',
      },
    },
  },
  buttons: {
    show_transfers: 'Vis overførsler',
    hide_transfers: 'Skjul overførsler',
    create: 'Opret',
    download_pdf: 'Download PDF',
    open_payment_page: 'Åbn betalingsside',
    open_invoice_page: 'Åbn fakturadetaljer',
    add_item: 'Tilføj post',
    convert_to_internal_billing: 'Opkræv fra salg i stedet',
    recharge_invoice: 'Opkræv faktura igen',
  },
  toasts: {
    failed_to_load_data: 'Data kunne ikke indlæses',
    failed_to_create_invoice: 'Fakturaen kunne ikke oprettes!',
    invoice_got_created: 'Fakturaen er oprettet!',
    invoice_got_recharged: 'Fakturaen er opkrævet igen. Ny betaling behandles!',
    failed_to_recharge_invoice: 'Fakturaen kunne ikke opkræves igen!',
    invoice_got_converted_to_internal_billing:
      'Fakturaen er konverteret til salgsfakturering. Det udestående beløb fratrækkes kommende udbetalinger.',
    failed_to_convert_invoice_to_internal_billing: 'Fakturaen kunne ikke konverteres til salgsfakturering!',
  },
};
